import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ChevronDownIcon } from "@gemini/icons";
export const IconElement = ({ isExpanded }) => {
    const Icon = ChevronDownIcon;
    return (_jsx(Box, { borderRadius: "radius.rounded", backgroundColor: "color.background.light", width: "sizing.24", height: "sizing.24", display: "flex", alignItems: "center", justifyContent: "center", children: _jsx(Icon, { transform: isExpanded ? "rotate(180deg)" : "", transitionDuration: "unsafe_component.accordion.motionDuration", transitionTimingFunction: "unsafe_component.accordion.motionEasing", size: "sizing.16" }) }));
};
